import React from 'react';
import ReactDOM from 'react-dom';
import * as ConfiguratorActions from '../actions/configurator'
import * as DocumentStorageActions from '../actions/documentStorage'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl';
import { push } from 'react-router-redux';
import ConfirmModal from './ConfirmModal.react';

class ConfiguratorAdmin extends React.Component {

    constructor(props) {
        super(props);
        this.refreshConfigurator = this.refreshConfigurator.bind(this);
        this.deleteStorage = this.deleteStorage.bind(this);
    }


    refreshConfigurator() {
        const { ConfiguratorManager, dispatch } = this.props;
        dispatch(ConfiguratorActions.refreshConfiguratorDataByDocument(ConfiguratorManager.getDocumentId()));
    }

    deleteStorage() {
        const { ConfiguratorManager, dispatch } = this.props;
        dispatch(DocumentStorageActions.deleteDocumentStorage(ConfiguratorManager.getStorageId()));
        dispatch(push('/dashboard'));

    }

    handleClick() {
        const data = {
            title: this.props.intl.formatMessage({id: 'LABEL_DELETE_DOCUMENT_STORAGE'}).toString(),
            msg: this.props.intl.formatMessage({id: 'CONFIRM_DELETE_DOCUMENT_STORAGE'}).toString(),
            cancelMsg: this.props.intl.formatMessage({id: 'LABEL_CANCEL'}).toString(),
            callback: this.deleteStorage
        };

        ReactDOM.render(<ConfirmModal openModal={true} data={data}/>, document.getElementById('confirm-modal-overlay'));

    }

    render() {
        return (
            <aside className="btn-group-bottom">
                <div className="btn-group-vertical" role="group" aria-label="Dokument neu laden">
                    <button type="button" className="btn btn-info btn-block" onClick={() => this.refreshConfigurator()}>
                        <i className="material-icons">restore_page</i><FormattedMessage id="LABEL_REFRESH" />
                    </button>
                    <button type="button" className="btn btn-default btn-block" onClick={() => this.handleClick()} >
                        <i className="material-icons">delete_forever</i><FormattedMessage id="LABEL_DELETE_DOCUMENT_STORAGE" />
                    </button>
                </div>
            </aside>
        )
    }
}

export default connect(
    state => ({ configurator: state.configurator, documentStorage: state.documentStorage, intl: state.intl })
)(injectIntl(ConfiguratorAdmin));


// WEBPACK FOOTER //
// ./src/js/components/ConfiguratorAdmin.react.jsx